export default __webpack_public_path__ + "static/media/play-button.901458ec.svg";